(() => {
  const form = document.getElementById('EntryCountryForm');
  if (!form) return;
  const select = form.querySelector('[name="country_code"]');
  const current = form.dataset.entryCountry;
  const returnTo = form.querySelector('[name="return_to"]');
  if (returnTo) returnTo.value = location.pathname + location.search;
  const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, value); } catch {} };
  form.addEventListener('submit', () => write(localStorage, 'oreylo-country-choice', select.value));
  if (read(localStorage, 'oreylo-country-choice') || read(sessionStorage, 'oreylo-entry-localized') || Number(form.dataset.entryCartCount) > 0) return;
  write(sessionStorage, 'oreylo-entry-localized', '1');
  fetch(`/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${encodeURIComponent(current)}`, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(5000) })
    .then(response => response.ok ? response.json() : null)
    .then(result => {
      const suggested = result?.suggestions?.map(item => item.parts?.country).find(country => country?.handle && country.confidence >= 0.8);
      if (!suggested || suggested.handle === current || ![...select.options].some(option => option.value === suggested.handle)) return;
      select.value = suggested.handle;
      form.submit();
    }).catch(() => {});
})();
